<div class="singleChoiceOption" [class.inEditMode]="inEditMode">
	@if (item) {
		<mat-radio-group
			[value]="item.answer"
			[disabled]="mode !== AssessablePanelMode.Answer"
			(change)="handleRadioButtonChange($event.value)"
		>
			@for (option of item.options; track $index) {
				<div class="radioContainer">
					@if (inEditMode) {
						<button
							mat-icon-button
							color="warn"
							class="remove"
							[@zoomInOnEnter]
							style="align-self: center"
							(click)="onRemoveOption.emit($index)"
						>
							<mat-icon fontSet="fad" fontIcon="fa-trash-alt" />
						</button>
					}

					<mat-radio-button [value]="$index" (click)="handleClick($index)" color="accent" style="margin-right: 30px">
						@if (inEditMode) {
							<div class="itemEdit" [@zoomInOnEnter]>
								<ng-container *ngTemplateOutlet="optionTemplate; context: {$implicit: {i: $index}}" />
							</div>
						} @else {
							<sim-rich-text-editor-view [@zoomInOnEnter] [content]="option" />
						}
					</mat-radio-button>

					<ng-container *ngTemplateOutlet="scoreTemplate; context: {$implicit: {i: $index}}" />
				</div>
			}

			@if (!inEditMode && !item.options) {
				<div class="noOptionsAddedYet">
					<div class="text">
						{{ T.SHARED_EXPANSION_NO_OPTION_ADDED_FOR_SINGLE_CHOICE | translate }}
						{{ T.SHARED_EXPANSION_CLICK_TO_ADD_OPTION | translate }}
					</div>
				</div>
			}
		</mat-radio-group>
	}

	@if (inEditMode) {
		<div class="addOptionButton" [@zoomInOnEnter]>
			<button mat-mini-fab color="accent" (click)="onAddOption.emit()">
				<mat-icon fontSet="fa" fontIcon="fa-plus" inline />
			</button>
		</div>
	}
</div>
